import CountUpNumbers from "./Classes/CountUpNumbers";
import Swiper from "swiper";
import  {Navigation, Pagination} from "swiper/modules";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Cv from "./Classes/Cv";
import Animation from "./Classes/Animation";
import XDownloader from "./Classes/XDownloader";
import xdownloaderConfig from "./xdownloader-config";
import Lottie from "./Classes/Lottie";
import Accordion from "./Classes/Accordion";

window.addEventListener("page_event_load", () => {

  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new CountUpNumbers({
    numbersSelector: '.lc-keyfigure__number',
    classIn: 'in-viewport',
    classOut: 'not-in-viewport',
    langArray: ['de','en'],
    decimalArray: ['.', '.'],
    thousandSepArray: [' ',' '],
  });

  new Lottie();

  const swiperElement = document.querySelectorAll(".swiper");

  if(swiperElement.length > 0) {
    swiperElement.forEach(swiper => {
      const swiperWrapper = swiper.querySelector(".swiper-wrapper");
      const swiperSlides = swiper.querySelectorAll(".swiper-slide");

      swiperSlides.forEach((slide,_) => {
        const clonedSlide = slide.cloneNode(true);
        swiperWrapper.appendChild(clonedSlide);
      });
    });
  }

  new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function() {
        let container = document.createElement('div');
        container.classList.add('swiper-pagination-bullet__container');
        let bullets = this.hostEl.querySelectorAll('.swiper-pagination-bullet');
        for(let i = (bullets.length/2); i <= bullets.length - 1; i++) {
          container.append(bullets[i]);
        }
        this.hostEl.querySelector('.swiper-pagination').append(container);
      }
    }
  });

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new Animation();

  new Cv({
    cvSelector: '.lc-cv'
  })

  new XDownloader(xdownloaderConfig);
});

window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});


window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});
